import React, { memo } from 'react';
import { Button } from '@mui/material';

const LoginButton = ({ loggedIn, logOutPress, logInPress, fullWidth = true }) => {
  const handleClick = loggedIn ? logOutPress : logInPress;

  return (
    <Button
      variant="text"
      fullWidth={fullWidth}
      style={{
        textTransform: 'uppercase',
        justifyContent: 'center',
      }}
      onClick={handleClick}
      sx={{ width: "50%" }}
    >
      {loggedIn ? 'LOG OUT' : 'LOG IN'}
    </Button>
  );
}

export default memo(LoginButton);
